import axios from '@/utils/axios'
import { ref } from 'vue'
import { role, sklad1c } from '@/controlles/auth'

const categoryProduct = ref([])

const getCategoryAll = async (sk = null) => {
  try {
      var sklads = sklad1c.value
      if(sk !== null){
        sklads = sk
      }
      var data = await axios.post('https://api.ultimatum.store/arm/club/category', { sklad: sklads })
      categoryProduct.value = data
  } catch (e) {
    console.log(e)
  }
}

export {
  getCategoryAll,
  categoryProduct
}
